import { render, staticRenderFns } from "./WebsiteLayout.vue?vue&type=template&id=a89b04d6&scoped=true&"
import script from "./WebsiteLayout.vue?vue&type=script&lang=js&"
export * from "./WebsiteLayout.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteLayout.vue?vue&type=style&index=0&id=a89b04d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b04d6",
  null
  
)

export default component.exports